export default __webpack_public_path__ + "static/media/icon-stove.4fc3b223.svg";